import { t } from "i18next";
import React from "react";
import { Trans } from "react-i18next";
import { useParams } from "react-router-dom";
import phConfused from "../../../assets/images/blurred2/imoji/Confused.png";
import phThumbDown from "../../../assets/images/blurred2/imoji/thumb_down_1.png";
import phThumbUp from "../../../assets/images/blurred2/imoji/thumb_up_1.png";
import HorizontalLeftButton from "../../../components/HorizontalLeftButton";
import MobileViewLayout from "../../../layouts/MobileViewLayout";
import { addS3Url } from "../../../utils/modules";

const imagesToPreload = {
  male: ["/workBalance/work-balance.jpg"],
  female: ["/workBalance/work-balance-female.jpg"],
};

const buttonText = [
  t("remote_work.yes"),
  t("remote_work.maybe"),
  t("remote_work.no"),
];

const data = [
  {
    image: addS3Url("/imoji/thumb_up_1.png"),
    placeHolderImage: phThumbUp,
  },
  {
    image: addS3Url("/imoji/Confused.png"),
    placeHolderImage: phConfused,
  },
  {
    image: addS3Url("/imoji/thumb_down_1.png"),
    placeHolderImage: phThumbDown,
  },
];

const RemoteWork = () => {
  const params = useParams();
  const gender = params.gender || "female";

  return (
    <MobileViewLayout>
      <div className="d-flex flex-column justify-content-center align-items-center remote-outer-div px-4">
        <h2 className="text-black fw-bold text-center  m-0 fs30 remote-selection-heading">
          <Trans i18nKey={"remote_work.question"} />
        </h2>
        <div className="w-100  d-flex flex-column gap-1 income-slab-option ">
          {data.map((item, index) => (
            <HorizontalLeftButton
              key={index}
              navigateTo={{
                pathname: `/${params.gender}/workbalance`,
              }}
              className="remote-button-text fs18 text-capitalize"
              label={buttonText[index]}
              imgClass="button-image"
              imagesToPreload={imagesToPreload[gender]}
              {...item}
            />
          ))}
        </div>
      </div>
    </MobileViewLayout>
  );
};

export default RemoteWork;
